const environments = {

  staging: {
    url: process.env.REACT_APP_API_URL,
  },

  local: {
    url: process.env.REACT_APP_API_URL,
  },
  prod: {
    url: process.env.REACT_APP_API_URL,
  },
};
export default environments;
